import BaseService from './base.service';

export default class CompanyBusinessService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getCompanyBusiness = query => {
        return this.get('/company-business/', query);
    };
}
